export const RSVP_COMMERCE_FUNCTION_URL =
  process.env.REACT_APP_RSVP_COMMERCE_FUNCTION_URL ||
  "https://us-central1-invitations778.cloudfunctions.net/manageRsvpCommerce";

export const callRsvpCommerce = async ({ idToken, eventId, action, payload = {} }) => {
  const response = await fetch(RSVP_COMMERCE_FUNCTION_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${idToken}` },
    body: JSON.stringify({ eventId, action, ...payload }),
  });
  const result = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(result.message || "RSVP_COMMERCE_REQUEST_FAILED");
    error.code = result.code || `HTTP_${response.status}`;
    error.details = result.details;
    throw error;
  }
  return result;
};

export const submitCheckoutRequest = (checkoutRequest) => {
  if (checkoutRequest?.method !== "POST" || !/^https:\/\//.test(checkoutRequest?.url || "")) {
    throw Object.assign(new Error("Invalid checkout response"), { code: "RSVP_COMMERCE_CHECKOUT_INVALID" });
  }
  const form = document.createElement("form");
  form.method = "POST";
  form.action = checkoutRequest.url;
  form.style.display = "none";
  Object.entries(checkoutRequest.fields || {}).forEach(([name, value]) => {
    const field = document.createElement("input");
    field.type = "hidden"; field.name = name; field.value = String(value); form.appendChild(field);
  });
  document.body.appendChild(form);
  form.submit();
};
